const quizQueryParams = {
  QUIZ_OVERVIEW_PARAM: "quizOverview",
  QUIZ_PREVIEW_PARAM: "quizPreview",
};

export default quizQueryParams;
